import { ExclusionListSelectorWebComponent } from './component/ExclusionListSelectorWebComponent';
import { WEB_COMPONENT_EXCLUSION_LIST_SELECTOR } from '../../webcomponents.constants';

/**
 * The exclusion lists selector component for selecting exclusions lists
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { ExclusionListSelectorWebComponent };

window.customElements.define(WEB_COMPONENT_EXCLUSION_LIST_SELECTOR, ExclusionListSelectorWebComponent);
